import { Injectable } from '@angular/core';
import { MqttAsyncApi, Router } from '@bdeo-platform/motor-private-async-api';
import { Subscriber } from '@bdeo-platform/motor-private-async-api/cjs/channels/';
import CompletedClaimPayload from '@bdeo-platform/motor-private-async-api/cjs/models/CompletedClaimPayload';
import { Smartphoto } from '@bdeo-motor/smartphoto-entities';

@Injectable({
  providedIn: 'root'
})
export class AsyncApiService {
  private domain: string | undefined;
  private client?: MqttAsyncApi;
  private router?: Router;

  public async subscriberWhenAIFinish(smartphoto: Smartphoto | undefined): Promise<Subscriber<CompletedClaimPayload> | undefined> {
    if (!smartphoto || !this.domain) {
      return;
    }

    const wsUrl = await fetch(`${this.domain}/async-api/connection/ws/uri`);

    if (!wsUrl) {
      throw new Error('async-api:error:ws');
    }

    const { id, masterCompanyId } = smartphoto;

    if (!this.client) {
      this.client = new MqttAsyncApi(await wsUrl.json(), id, [masterCompanyId]);
      this.router = new Router(this.client);
    }

    const channel = this.router?.channels['selfadjusts/{selfadjust_id}/ai/finished']({
      selfadjust_id: id
    });

    return channel?.subscriber;
  }

  public disconnect(): void {
    this.client?.disconnect();
    this.client = undefined;
  }

  public setDomain(domain: string): void {
    this.domain = domain;
  }
}
